export const SPACING_AUTO = 'auto';

export const SPACING_000 = '0px';

export const SPACING_001 = '1px';

export const SPACING_004 = '4px';

export const SPACING_008 = '8px';

export const SPACING_012 = '12px';

export const SPACING_016 = '16px';

export const SPACING_020 = '20px';

export const SPACING_024 = '24px';

export const SPACING_028 = '28px';

export const SPACING_032 = '32px';

export const SPACING_036 = '36px';

export const SPACING_040 = '40px';

export const SPACING_048 = '48px';

export const SPACING_056 = '56px';

export const SPACING_064 = '64px';

const BasicSpacing = {
    SPACING_AUTO,
    SPACING_000,
    SPACING_001,
    SPACING_004,
    SPACING_008,
    SPACING_012,
    SPACING_016,
    SPACING_020,
    SPACING_024,
    SPACING_028,
    SPACING_032,
    SPACING_036,
    SPACING_040,
    SPACING_048,
    SPACING_056,
    SPACING_064,
};

export default BasicSpacing;
